/*
* 
* API for sending snaphot images of app to user's profiles.
* picture argument should be converted to base64.
* 
*/
define('app_image',['sdk/api'], function(API){
  return {
    submit: function(picture, cb) {
      API.api('/profile/app_image', 'POST', {picture: picture}, function(response){
        if(cb){
          cb(response);
        }
      })
    }
  }
});

